import { Button } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import React from 'react';

import { TICKET_CATEGORY_TABLE_BASIC_COLUMNS } from './constants';
import styles from './index.module.scss';
import type { ModalType, TicketCategoryTableData } from './types';

export const getTicketCategoryTableColumns = (
  setCurrentData: (record: TicketCategoryTableData) => void,
  handleModalOpen: (type: ModalType) => void
) => {
  const columns: ColumnsType<TicketCategoryTableData> = [
    ...TICKET_CATEGORY_TABLE_BASIC_COLUMNS,
    {
      title: '操作',
      dataIndex: 'action',
      width: 250,
      fixed: 'right',
      render: (_, record) => {
        // TODO: 按鈕的onClick邏輯都待做

        return (
          <div className={styles.actionColumn}>
            <Button
              type="primary"
              onClick={() => {
                setCurrentData(record);
                handleModalOpen('view');
              }}
            >
              查看
            </Button>
            <Button
              onClick={() => {
                setCurrentData(record);
                handleModalOpen('edit');
              }}
            >
              編輯
            </Button>
            <Button
              type="primary"
              danger
              onClick={() => console.log('Delete Ticket Category:\n', record)}
            >
              刪除
            </Button>
          </div>
        );
      },
    },
  ];
  return columns;
};
